import {Chip, Stack, Typography} from '@mui/material';
import {MissingFact} from './missingFacts';

/** What this work item still has to record, each fact a shortcut to its control. Live: it follows unsaved edits. */
export function ReviewStrip({facts, onGo}: {facts: MissingFact[]; onGo: (fact: MissingFact) => void}) {
  if (!facts.length) {
    return <Typography variant="body2" color="success.main" data-testid="review-facts">✓ Nothing left to review on this work item</Typography>;
  }
  return (
    <Stack data-testid="review-facts" direction="row" alignItems="center" useFlexGap flexWrap="wrap" spacing={0.75} role="group" aria-label="Facts to review">
      <Typography variant="body2" color="text.secondary" fontWeight={500}>{facts.length} to review:</Typography>
      {facts.map(fact => <Chip key={fact.field} size="small" variant="outlined" label={fact.label} onClick={() => onGo(fact)}/>)}
    </Stack>
  );
}
